import React from 'react';
import { Formik, Form, Field } from 'formik';
import { WizardContext } from 'react-albus';
import { monthlySavingsValidation } from '../validations';
import { saveItem, getExistingData } from '../helper';
import FormikMaskedInput from '../../CommonComponents/FormikMaskedInput';
import { currencyMask } from '../../CommonComponents/MaskedInput';
import Header from '../Components/Header';
import WizardProgress from '../Components/WizardProgress';

interface Props {
  wizard: WizardContext;
}

const MonthlySavings: React.FC<Props> = ({ wizard }) => {
  const { next } = wizard;
  const { MonthlyRetirementSavings } = getExistingData();

  return (
    <div id="ExpressWizard_Input_Retirement" className="adv-form ExpressWizard">
      <Header wizard={wizard} />
      <WizardProgress wizard={wizard} />
      <Formik
        initialValues={{
          MonthlyRetirementSavings: MonthlyRetirementSavings || '',
        }}
        validationSchema={monthlySavingsValidation}
        onSubmit={values => {
          saveItem(values);
          next();
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <ul className="questions">
              <li style={{ display: 'block' }}>
                <ul className="horizontal-layout">
                  <li>
                    <label>How much do you save monthly for retirement?</label>
                    <div
                      className={`input underline ${
                        errors.MonthlyRetirementSavings && touched.MonthlyRetirementSavings
                          ? 'invalid'
                          : ''
                      }`}
                      style={{ width: '228px', float: 'none', margin: '0 auto' }}
                    >
                      <i style={{ marginRight: '10px' }}>$</i>
                      <Field
                        className="input-container"
                        name="MonthlyRetirementSavings"
                        component={FormikMaskedInput}
                        mask={currencyMask}
                        placeholder="0"
                        style={{ width: '160px' }}
                      />
                    </div>
                  </li>
                </ul>
              </li>
            </ul>

            <div className="action">
              <button type="submit" className="primary flat next">
                Next
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default MonthlySavings;
